module.exports = __webpack_public_path__ + "static/montserrat-bold-webfont-9ccbf243d3c7add1a29a6df166797523.woff2";